
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/resources/cli",
      function () {
        return require("private-next-pages/docs/resources/cli.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/resources/cli"])
      });
    }
  